import axios from "axios"

export type DatasetInfo = {
  name: string
  github_folder: string
  related_pages: {
    title: string
    url: string
  }[]
}

export const DATASETS_URL =
  "https://raw.githubusercontent.com/InterruptorPt/dados/main/repo-contents.json"

export const getDatasetsInfo = async (): Promise<DatasetInfo[]> => {
  const { data } = await axios.get<DatasetInfo[]>(DATASETS_URL)

  return data
}
